import React, { useState } from 'react';
import './AIHeroSection.css';

const AIHeroSection = () => {
   const [prompt, setPrompt] = useState('');

   const handleSubmit = () => {
      if (prompt.trim()) {
         console.log("Generating website for:", prompt);
         // Logic to handle generation or navigation can be added here
      }
   };

   const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
         handleSubmit();
      }
   };

   return (
      <section className="ai-hero-section">
         {/* Decorative blurred circles */}
         <div className="hero-shape shape-1"></div>
         <div className="hero-shape shape-2"></div>
         <div className="hero-shape shape-3"></div>
         <div className="hero-shape shape-4"></div>

         <div className="ai-hero-content">
            <h1 className="ai-hero-title">Professional Websites. Powered by AI. Perfected by Humans.</h1>
            <p className="ai-hero-subtitle">
               We handle the website. You focus on the business.
            </p>
            <div className="ai-input-container disabled">
               <div className="ai-input-wrapper">
                  <i className="fas fa-lock ai-input-icon"></i>
                  <input
                     type="text"
                     className="ai-input-field"
                     placeholder="Describe your business to generate a website…"
                     value={prompt}
                     disabled={true}
                     readOnly
                  />
               </div>
               <div className="ai-input-actions">
                  <div className="ai-coming-soon-text">
                     🚧 Website generation is currently under development. Coming soon.
                  </div>
                  <button className="ai-submit-btn" disabled={true}>
                     Generate Website
                  </button>
               </div>
            </div>

            <p className="ai-hero-description">
               WebDPro AI builds, customizes, and manages high-quality business websites using AI-assisted workflows and professional development standards.
            </p>
         </div>
      </section>
   );
};

export default AIHeroSection;
